module.exports = __webpack_public_path__ + "static/media/likes-img.28b28679.png";